export class ObjectWithId {
    public internalGlobalId: number;
    private static currentId: number = 1;
    private static listOfObjects: ObjectWithId[] = [];

    constructor() {
        this.internalGlobalId = ObjectWithId.currentId;
        ObjectWithId.listOfObjects[ObjectWithId.currentId] = this;
        ObjectWithId.currentId = ObjectWithId.currentId + 1;
    }

    public static getById(internalId: number) {
        return ObjectWithId.listOfObjects[internalId];
    }
}
